






































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import * as _ from "lodash";
import { GetUserHospitals } from "@/request/hospitals";
import {
  GetGroups,
  GetTemplatesOfGroup,
  GetTopicsOfTemplate,
  DeletePatient,
  GetImportWayCenterList,
  PostFetchPatients,
} from "@/request/projects";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import Header from "../../../components/project-detail-header.vue";
import LeftNav from "../../../components/project-detail-left-nav.vue";
import ProjectSetting from "../../components/project-setting/project-setting.vue";
import AddPatientDialog from "./add-patient-dialog.vue";
import importDataDialog from "./import-data-dialog.vue";
import ForbiddenDialog from "./forbidden-dialog.vue";
import SelectMultiSearch from "./select-multi-search.vue";
@Component({
  components: {
    Copy,
    ConfirmDialog,
    Header,
    LeftNav,
    Pagination,
    ProjectSetting,
    AddPatientDialog,
    importDataDialog,
    ForbiddenDialog,
    SelectMultiSearch,
  },
})
export default class ResearchListFolder extends Vue {
  private projectId: any = "";
  private project: any = {};
  // 导入导出条件
  private importWayCenters: any[] = [];
  private addPatientWay: any = "";
  private addPatientDataWay: any = "";
  // 搜索条件
  private groups: any[] = [];
  private hospitals: any[] = [];
  private filters: any = {
    范围: [],
    group_id: "",
    hospital_ids: "",
    searchText: "",
    timeWay: "",
    time: [],
    条件: "",
    研究指标: [],
  };
  private searchedTemplates: any[] = [];
  private ifShowPrimarySearch: boolean = false;
  private ifPrimarySearched: boolean = false;
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "0";
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private patients: any[] = [];
  private interviews: any[] = [];
  // 弹窗
  private cPatient: any = {};
  private ifShowAddPatientDialog: boolean = false;
  private ifShowImportDataDialog: boolean = false;
  private ifShowForbiddenDialog: boolean = false;
  private cCenter: any = {};
  // 确认弹窗
  private confirmState: any = "delete";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any = "确定要移除该患者吗？";
  // 项目设置
  private ifShowSet: boolean = false;

  @Watch("$route.params.project_id", { immediate: true })
  private paramsChange(id) {
    if (id) {
      this.projectId = id;
      this.fetchProject();
      this.fetchHospitals();
      this.fetchGroups();
      this.fetchImportWayCenters();
      this.resetPrimarySearch();
    }
  }

  @Watch("filters.group_id")
  private filterGroupChange() {
    this.fetchTemplates();
    this.resetPrimarySearch();
  }
  /**
   * @description 获取项目详情
   */
  private fetchProject() {
    const params: any = {
      params: {
        project_id: this.projectId,
      },
    };
    axios.get("api/project", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.project = data.data;
      });
    });
  }
  /**
   * @description 获得导入数据和患者的分中心列表
   */
  private fetchImportWayCenters() {
    const params: any = {
      params: {
        project_id: this.projectId,
      },
    };
    GetImportWayCenterList(this, params).then((data: any) => {
      this.importWayCenters = data;
    });
  }
  /**
   * @description 添加研究对象分类实现
   */
  private addPatientWayChange(val) {
    switch (val) {
      case "单个添加":
        this.ifShowAddPatientDialog = true;
        break;
      default:
        this.$router.push({
          path: "/main/project/import-patient",
          query: {
            center_id: val.center,
            center_name: val["项目名称"],
            src_project_id: val.project_id,
            project_id: this.project.project_id,
          },
        });
        break;
    }
    this.addPatientWay = "";
  }
  /**
   * @description 导入研究数据功能
   */
  private startImportData(val) {
    this.cCenter = val;
    // switch (val.center) {
    //   case "治未病数据中心":

    //     break;
    // }
    this.ifShowImportDataDialog = true;
  }
  /**
   * @description 获取该项目下的所有分组
   */
  private fetchGroups() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          project_id: this.projectId,
        },
      };
      GetGroups(this, this.projectId).then((data: any) => {
        this.groups = data;
        this.filters.group_id = this.groups[0].group_id;
        resolve();
      });
    });
  }
  /**
   * @description 获取该项目所属的所有分中心
   */
  private fetchHospitals() {
    GetUserHospitals(this, this.projectId).then((data: any) => {
      this.hospitals = data;
      // this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
    });
  }
  /**
   * @description 搜索机构
   */
  private searchHospitals(ev) {
    GetUserHospitals(this, this.projectId, ev).then((data: any) => {
      if (this.filters["范围"].length > 0) {
        data.unshift(this.filters["范围"][0]);
      }
      this.hospitals = _.uniqBy(data, "hospital_id");
    });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(this, this.projectId, this.filters.group_id).then(
      (data: any) => {
        this.searchedTemplates = data;
      }
    );
  }
  /**
   * @description 完成添加研究数据
   */
  private finishAddPaitentData() {
    this.addPatientDataWay = "";
    this.search();
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级搜索
   */
  private resetPrimarySearch() {
    this.filters.timeWay = "";
    this.filters.time = [];
    this.filters["条件"] = "";
    this.filters["研究指标"] = [];
    this.ifPrimarySearched = false;
    this.currentPage = 1;
    this.fetchPatients();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.resetPrimarySearch();
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.fetchPatients();
  }
  /**
   * @description 跳转数据导出页面
   */
  private jumpDataExport() {
    this.$router.push("/main/project/data-filter-folder/" + this.projectId);
  }
  /**
   * @description 获取病人列表
   */
  private fetchPatients() {
    this.ifLoading = true;
    this.filters.hospital_ids = [];
    this.filters["范围"].forEach((item: any) => {
      this.filters.hospital_ids.push(item["hospital_id"]);
    });
    if (this.filters.hospital_ids.includes("")) {
      this.filters.hospital_ids = [];
    }
    const params: any = {
      hospital_ids: this.filters.hospital_ids,
      project_id: this.projectId,
      group_id: this.filters.group_id,
      order_field: this.cSortField,
      order_value: this.cSortValue,
      current_page: this.currentPage,
      page_count: this.pageSize,
      search: this.filters.searchText,
      条件: this.filters["条件"],
    };
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
      this.ifPrimarySearched = true;
    }
    if (this.filters["研究指标"].length > 0) {
      this.ifPrimarySearched = true;
      const arr: any[] = [];
      this.filters["研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["研究指标"] = arr;
    }
    axios.post("api/project/yjdl/patients", params).then(({ data }) => {
      resHandle(this, data)
        .then(() => {
          this.patients = data.data.patients;
          this.interviews = data.data.interviews;
          this.totalPage = data.data.total_page;
          this.totalCount = data.data.total_count;
          this.ifShowPrimarySearch = false;
        })
        .finally(() => {
          this.ifLoading = false;
        });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchPatients();
  }
  /**
   * @description 禁用
   */
  private jinyong(patient) {
    this.cPatient = patient;
    this.ifShowForbiddenDialog = true;
  }
  /**
   * @description 启用
   */
  private qiyong(patient) {
    const params: any = {
      patient_id: patient.patient_id,
      project_id: patient.project_id,
      group_id: patient.group_id,
      action: "启用",
    };
    axios.post("api/project/patient/do", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("启用成功");
        this.fetchPatients();
      });
    });
  }
  /**
   * @description 处理弹窗取消
   */
  private handleCancel() {
    this.confirmVisible = false;
  }
  /**
   * @description 处理弹窗确定
   */
  private handleConfirm() {
    switch (this.confirmState) {
      case "delete":
        this.shanchu();
        break;
    }
  }
  /**
   * @description 打开是否确定清空项目数据弹窗
   */
  private openIfDeleteConfirm(patient) {
    this.confirmState = "delete";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "确定要移除该患者吗？";
    this.confirmVisible = true;
    this.cPatient = patient;
  }
  /**
   * @description 删除一个患者
   */
  private shanchu() {
    const params: any = {
      data: {
        patient_id: this.cPatient.patient_id,
        project_id: this.project.project_id,
        group_id: this.filters.group_id,
      },
    };
    DeletePatient(this, params).then(() => {
      this.$message.success("删除成功");
      this.confirmVisible = false;
      console.log(this.patients.length);
      if (this.currentPage >= this.totalPage && this.patients.length === 1) {
        this.currentPage = this.totalPage - 1;
      }
      this.fetchPatients();
    });
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  /**
   * @description 跳转编辑详情
   */
  private goToCompose(patient) {
    const query: any = {
      project_id: patient.project_id,
      group_id: patient.group_id,
      patient_id: patient.patient_id,
    };
    // const { href } = this.$router.resolve({
    //   path: "/main/project/research-list-compose",
    //   query
    // });
    // window.open(href, "_blank");
    this.$router.push({
      path: "/main/project/research-list-compose",
      query,
    });
  }
  /**
   * @description 处理添加患者完成
   */
  private handleAddedFinish(ev) {
    this.ifShowAddPatientDialog = false;
    this.goToCompose(ev);
  }
  // /**
  //  * @description 初始化
  //  */
  // private beforeMount() {
  //   this.projectId = this.$route.params.project_id;
  //   this.fetchProject();
  //   this.fetchHospitals();
  //   this.fetchGroups();
  //   this.fetchImportWayCenters();
  // }
}
